import { useCallback } from "react";
import apiClient2 from "../../api/apiClient2";
import apiPaths from "../../api/endpoints";
import { StoryData } from "../containers/Rooms/types";

/**
 * Exposes a bare `retrieveStoryData(queryString?)` fetcher.
 * Rooms calls it manually inside `initialJourneyApiCall` so it can
 * do the two-step fetch the same way the mobile side does.
 */
export function useRetrieveStory() {
  const retrieveStoryData = useCallback(
    async (queryString?: string): Promise<StoryData | null> => {
      try {
        const url = queryString
          ? `${apiPaths.RETRIEVE_STORY}${queryString}`
          : apiPaths.RETRIEVE_STORY;
        const res = await apiClient2.get(url);
        const outer = res.data;
        const inner = outer?.data ?? outer;
        // storyId lives at the outer envelope level, merge it into the story object
        return {
          ...inner,
          storyId: outer?.storyId ?? inner?.storyId,
          onBoardingDoodle: outer?.onBoardingDoodle ?? inner?.onBoardingDoodle,
          isOnboardingCompleted:
            outer?.isOnboardingCompleted ?? inner?.isOnboardingCompleted,
        } as StoryData | null;
      } catch (err: any) {
        console.error("useRetrieveStory error:", err);
        return null;
      }
    },
    [],
  );

  return { retrieveStoryData };
}
